// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"styles_paragraph__HCQjT"};